import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { pieArcLabelClasses, PieChart } from '@mui/x-charts/PieChart';

interface PieChartData {
    id: number;
    label: string;
    value: number;
}

interface PieChartComponentProps {
    data: PieChartData[];
    height?: number;
    title: string;
}

function PieChartComponent({ data, height = 275, title }: Readonly<PieChartComponentProps>) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Stack
            sx={{
                flex: 1,
            }}
        >
            <Typography sx={{ mb: 1 }} variant="subtitle2">
                {title}
            </Typography>
            <PieChart
                height={!isSmall ? height : undefined}
                series={[
                    {
                        arcLabel: (item) => item.value.toString(),
                        cornerRadius: 4,
                        cx: isSmall ? '70%' : undefined,
                        cy: isSmall ? '35%' : undefined,
                        data,
                        highlightScope: { fade: 'global', highlight: 'item' },
                        innerRadius: 30,
                        paddingAngle: 2,
                    },
                ]}
                slotProps={{
                    legend: {
                        direction: isSmall ? 'row' : 'column',
                        hidden: false,
                        padding: { bottom: 60, left: 10, right: 10 },
                        position: isSmall
                            ? {
                                  horizontal: 'middle',
                                  vertical: 'bottom',
                              }
                            : { horizontal: 'right', vertical: 'middle' },
                    },
                }}
                sx={{
                    ['.MuiChartsLegend-mark']: {
                        rx: '50%',
                    },
                    [`& .${pieArcLabelClasses.root}`]: {
                        fill: 'white',
                        fontSize: 16,
                        fontWeight: 'bold',
                        textShadow: '0px 0px 2px rgba(0,0,0,0.5)',
                    },
                }}
            />
        </Stack>
    );
}

export default PieChartComponent;
